import * as React from 'react'

export const SvgContentEmailUsp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} aria-hidden={true} {...props}>
    <path d="M21.04 19a1.006 1.006 0 01-.08 0H3.04a1.006 1.006 0 01-.08 0H2V6.007 5h20v14h-.96zm-2.455-2l-4.297-4.297-2.342 1.89-2.27-1.854L5.414 17h13.17zM20 15.587V8.092l-4.147 3.347L20 15.587zm-16 0l4.118-4.12L4 8.108v7.48zM5.807 7l6.146 5.016L18.17 7H5.807z" />
  </svg>
)
export default SvgContentEmailUsp
